import Swiper from 'swiper'

import { isMobileHomePage } from '@/modules/globals'

function createPlaceholderForSlider () {
  const div = document.createElement('div')
  div.classList.add('swiper-wrapper')
  return div
}

function wrapNodesIntoPlaceholder (root) {
  const wrapper = createPlaceholderForSlider(root)

  Array.from(root.children).forEach(el => {
    el.classList.add('swiper-slide')
    wrapper.insertAdjacentElement('beforeend', el)
  })

  return root.insertAdjacentElement('afterbegin', wrapper)
}

function runSliderOnOffers (root) {
  return new Swiper(root, {
    loop: true,
    autoplay: true,
    slidesPerView: 1,
  })
}

export function init () {
  const root = document.querySelector('.offer-list__slider')

  if (root && isMobileHomePage()) {
    wrapNodesIntoPlaceholder(root)
    runSliderOnOffers(root)    
  }
}


// WEBPACK FOOTER //
// ./src/modules/topOffers.js